import axios from 'axios';
import store from '@/store/index';

axios.defaults.baseURL = 'https://api.s4112037-ct4034.uogs.co.uk/';
axios.defaults.headers.common.Authorization = 'Bearer ' + (localStorage.getItem('UserToken') !== null ? localStorage.getItem('UserToken') : 'null');
